module.exports = [
    {
        "ids": 28,
        "genre": "Action"
    },
    {
        "ids": 12,
        "genre": "Adventure"
    },
    {
        "ids": 16,
        "genre": "Animation"
    },
    {
        "ids": 35,
        "genre": "Comedy"
    },
    {
        "ids": 80,
        "genre": "Crime"
    },
    {
        "ids": 99,
        "genre": "Documentary"
    },
    {
        "ids": 18,
        "genre": "Drama"
    },
    {
        "ids": 10751,
        "genre": "Family"
    },
    {
        "ids": 14,
        "genre": "Fantasy"
    },
    {
        "ids": 36,
        "genre": "History"
    },
    {
        "ids": 27,
        "genre": "Horror"
    },
    {
        "ids": 10402,
        "genre": "Music"
    },
    {
        "ids": 9648,
        "genre": "Mystery"
    },
    {
        "ids": 10749,
        "genre": "Romance"
    },
    {
        "ids": 878,
        "genre": "Science Fiction"
    },
    {
        "ids": 10770,
        "genre": "TV Movie"
    },
    {
        "ids": 53,
        "genre": "Thriller"
    },
    {
        "ids": 10752,
        "genre": "War"
    },
    {
        "ids": 37,
        "genre": "Western"
    }
]